<template>
  <div>
    <div class="pur">
      <h5>注射信息</h5>
      <span>
        <el-button @click="edit" type="primary" size="mini">添加注射项目</el-button>
      </span>
    </div>
    <div class="card">
      <div v-for="(domain, index) in childInject " :key="index">
        <el-form-item label-width="100" label="注射项目名称">
          <el-input v-model="domain.injectionProjectName" placeholder="请输入注射项目名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="项目金额">
          <el-input v-model="domain.injectionProjectAmt" placeholder="请输入" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
        </el-form-item> -->
        <el-form-item label="送诊护士">
          <el-select @focus="focus(2)" @keydown.enter.native="enterDoctor($event,2,index)" ref="injectionNurseName" default-first-option :filter-method="aaMatch" v-model="domain.injectionNurseName" clearable placeholder="请选择护士" filterable remote>
            <el-option v-for="(item) in newList2" :key="item.id" :label="item.identityName" :value="item.identityName"></el-option>
          </el-select>
        </el-form-item>
        <el-button size="mini" type="danger" @click.prevent="remove(domain,index)" v-show="index > 0">
          <i class="el-icon-delete"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['childInject',],
  computed: {
    ...mapGetters(['list2']),
  },
  data() {
    return {
      newList2: [],
    }
  },
  methods: {
    focus(val) {
      if (val == 2) {
        this.newList2 = this.list2
      }
    },
    aaMatch(val) {
      this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
    },
    enterDoctor(e, val, index) {
      if (val == 2) {//护士
        if (this.newList2[0] != undefined) {
          this.childInject[index].injectionNurseName = this.newList2[0].identityName
          this.$forceUpdate()
          this.$refs.injectionNurseName[0].blur()
        }
      }
    },
    // 添加注射项目
    edit() {
      this.childInject.push({
        key: Date.now(),
        injectionProjectName: '',
        injectionProjectAmt: '',
        injectionNurseName: '',
      });
    },
    // 删除注射项目
    remove(item, listIndex) {
      var index = this.childInject.indexOf(item)
      if (index !== -1) {
        this.childInject.splice(listIndex, 1)
      }
    },
  }
}
</script>
<style scoped>
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.pur {
  display: flex;
  align-items: center;
}
.pur h5 {
  margin-right: 10px;
}
.card >>> .el-select .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
}
.card >>> .el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
</style>